import { OperationProgressItem } from ".";
import { AsyncOperationItem } from "./AsyncOperationItem";

interface AsyncOperationItemListProps {
  data: OperationProgressItem[];
  renderCompletedItem?: (item: OperationProgressItem) => React.ReactNode;
}

export const AsyncOperationItemList = ({
  data,
  renderCompletedItem,
}: AsyncOperationItemListProps) => {
  return (
    <div className="max-h-[65dvh] overflow-y-auto py-4 flex flex-col gap-2">
      {data.map((item, index) =>
        renderCompletedItem ? (
          <div key={index}>{renderCompletedItem(item)}</div>
        ) : (
          <AsyncOperationItem
            key={index}
            label={item.label}
            success={item.success}
            description={item.errorDescription}
          />
        ),
      )}
    </div>
  );
};
